import React from 'react';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { CreditCardNetwork } from '@wix/cashier-common/dist/src/enums/payments/CreditCardNetwork';
import { DH } from '../../utils/DataHook';
import * as s from './styles.scss';
import { CreditCardNetworkIcon } from '../PaymentMethodIcon/icons/CreditCardNetworkIcon';
import { useSelector } from 'react-redux';
import { selectLocale } from '../../redux/selectors';
import { PaymentMethodIcon } from '../PaymentMethodIcon';

const getCreditCardIconByType = (cardType: CreditCardNetwork) => (
  <div className={s.creditCardNetworkIcon}>
    <CreditCardNetworkIcon cardNetwork={cardType} />
  </div>
);

export const CollapsedPayment: React.FunctionComponent<{
  paymentMethod?: PaymentMethod;
  withIcon: boolean;
  creditCardType?: CreditCardNetwork;
  iconUrl?: string;
  title: string;
}> = (props) => {
  const locale = useSelector(selectLocale);
  const isCreditCard = props.paymentMethod === PaymentMethod.CreditCard;

  return (
    <div
      className={s.collapsedPayment}
      data-hook={DH.CollapsedPayment.Container}
    >
      {props.withIcon && (
        <span className={s.iconWrapper} data-hook={DH.CollapsedPayment.Icon}>
          {isCreditCard && props.creditCardType ? (
            getCreditCardIconByType(props.creditCardType)
          ) : (
            <PaymentMethodIcon
              paymentMethod={props.paymentMethod}
              url={props.iconUrl}
              lang={locale}
            />
          )}
        </span>
      )}
      {props.title}
    </div>
  );
};
CollapsedPayment.displayName = 'CollapsedPayment';
